import React from 'react';
import { useLeaflet } from "react-leaflet";
import axios from 'axios';
import L from 'leaflet';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import './VisualizzaAttributi.css'

var XMLParser = require('react-xml-parser');

function  ListaAttributi(props){

    const [name,setName] = React.useState("")
    const [boundingBox,setBoundingBox] = React.useState("")
    const [format,setFormat] = React.useState("")
    const [style,setStyle] = React.useState("")




    function callCapabilities(url) {
        
        var defaultParameters = {
        version: '1.1.0',
        request: 'GetCapabilities',
        };
        var parameters = L.Util.extend(defaultParameters);
        var URL = url + L.Util.getParamString(parameters);
        
        
        axios.get(URL,{headers: window.tp_headers})
        .then(response => {
        const paths = response.data
        
        
        var json = new XMLParser().parseFromString(paths);
                
                json.children.map(x => {
                    
                     if (x.name === "Capability"){
                        x.children.map(y=>{
                            if (y.name === "Layer"){
                                
                                y.children.map(z=>{
                                    if (z.name === "--All"){
                                      
                                        z.children.map(t=>{
                                            
                                            
                                            /* if (t.name === "BoundingBox"){
                                                const lon = [t.attributes.maxy, t.attributes.maxx] 
                                                const lng = [t.attributes.miny, t.attributes.minx]
                                                setBoundingBox(`${lon},${lng}`)
                                                map.fitBounds([lon,lng],{zoom:13})
                                                
                                            } */
                                            
                                            if(t.name === "Layer"){
                                              
                                                t.children.map(p =>{
                                                   
                                                    // if(p.name==="Style"){
                                                    //     p.children.map(m=>{
                                                    //         if(m.name === "LegendURL"){
                                                    //             setFormat(p.value)
                                                    //         }
                                                
                                                
                                                    //     })
                                                    // }
                                                }) 
                                            }
                                                 
                                            

                                        })
                                    }
    
                                })
                            }
                        })
                     }
                })
        })
        
        .catch( error => {
        const errorMsg = error.message 
        })
       }
        
        try {
            
        var url = props.data.attributi.attributi.value.serviceUrl
        if (url !== undefined){
            
        let len = url.lastIndexOf('/') + 1
        var output = url.substring(0, len) + `${props.data.attributi.attributi.value.name}/` + url.substring(len);
        //url = url.insert(len,`${props.data.attributi.attributi.value.name}/`)
        
        callCapabilities(output)
        }else {
            
        url = props.data.attributi.attributi.value.element.serviceUrl
        callCapabilities(url)
        }
        
        
        } catch (error) {
        
        } 
        
        const { map } = useLeaflet();
        
        /* const a = (url) =>{
            axios.get(url + "&request=GetCapabilities")
            .then(response => {
                const paths = response.data
                var json = new XMLParser().parseFromString(paths);
                setValue(json)
                json.children.map(x => {
                    
                     if (x.name === "Capability"){
                        x.children.map(y=>{
                            if (y.name === "Name"){
                                y.children.map(z=>{
                                    if (z.name === "Format"){
                                        z.children.map(t=>{
                                            if (t.name === "BoundingBox"){
                                                const lon = [t.attributes.maxy, t.attributes.maxx] 
                                                const lng = [t.attributes.miny, t.attributes.minx]
                                                map.fitBounds([lon,lng],{zoom:13})
                                            }
                                        })
                                    }
    
                                })
                            }
                        })
                     }
                })
    
            })
            .catch( error => {
                const errorMsg = error.message    
            })
        
        } */

        
    
        


        const useStyles = makeStyles({
            table: {
              minWidth: 650,
            },
          });

          function createData(record,nameData ,attributo,number) {
            return { record, nameData,attributo,number };
          }
          
          /* const rows = [
            createData('Record 1', props.data.attributi.attributi.value.name,'', boundingBox, url,1),
            createData('Record 2', 'stalli','', 39.223615 ,'',2),
            createData('Record 3', 'aereporti','', 39.223615, 'http://192.168.3.4:9090/geoserver/sardegna/wms?',3),
            createData('Record 4', 'porti','', 39.223615, 'http://192.168.3.4:9090/geoserver/sardegna/wms?',4),
            createData('Record 5', 'centroidi','', 39.223615, 'http://192.168.3.4:9090/geoserver/sardegna/wms?',5),
          ]; */
          const rows = [
            createData('Record 1','Nome',props.data.attributi.attributi.value.name,1),
            createData('Record 2','Formato',format,2),
            createData('Record 3','BoundingBox',boundingBox,3),
            createData('Record 4','Stile',style,4),
            createData('Record 5','Link del layer',url,5),
          ];

          
          const classes = useStyles();

         


    return(<div>

              
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell ><div className="testo">Record</div></TableCell>
            <TableCell ><div className="testo">Nome</div></TableCell>
            <TableCell ><div className="testo">Attributo</div></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          
            
            {rows.map((row) => (
            <TableRow key={row.name}>              
              <TableCell component="th" scope="row" class="d-flex">
                <TableCell class="p-3" ><div className="Radius"align="center">{row.number}</div></TableCell>
                <TableCell class="p-3">{row.record}</TableCell>                                                                                   
              </TableCell>              
              <TableCell align="left">{row.nameData}</TableCell>
              <TableCell align="left">{row.attributo}</TableCell>
            </TableRow>           
          ))}
        </TableBody>
      </Table>
    </TableContainer>
        
        

    </div>)



}


export default ListaAttributi;